/**
 * 拖拽上传文件组件
 * Author: FJJ
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/11/01     1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 * @param onChange          回调数据
 * @param accept            可选接受类型：格式 '.pdf, .jpg, .jpeg, .png',
 * @param flagLimitType     是否限制为当时已有数据类型,默认False,为Ture时，若当时有文件列表数据，即只接受当前文件列表数据的类型
 *
 *  辅助参数
 * @param multiple          是否支持多选文件，ie10+ 支持。开启后按住 ctrl 可选择多个文件,默认true
 * @param maxCount          限制上传数量。当为 1 时，始终用最新上传的文件代替当前文件
 * @param placeholder       扩展提示，有则优先显示
 * */
import React from 'react';
import {InboxOutlined} from "@ant-design/icons";
import { fexWebUploaderConfig } from "@config/upload";
import "./index.less";
import PropTypes from "prop-types";
import {isEmpty,trim,getFileSuffix} from '@utils/utils';
import {message, Upload,} from "antd";
import Lang from "@/components/Lang/Lang";
const { Dragger } = Upload;
class UploadFileComponent extends React.Component {
    static propTypes = {
        onChange: PropTypes.func,
        accept: PropTypes.string,
        flagLimitType: PropTypes.bool,
        multiple:PropTypes.bool,
        maxCount: PropTypes.any,
        maxSize: PropTypes.number,
    }
    static defaultProps = {
        initValue:[],
        accept:'*',
        flagLimitType:false,
        multiple:true,
        maxCount:'',
        maxSize:5*1024*1024,
        replace:false,
        placeholder:"",//扩展提示
    };
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            fileList:[],
            accept: props.accept,
            flagLimitType: props.flagLimitType,
            maxSize: props.maxSize,
        };
    }
    init(successFn) {
        const fileConfig = {
            ...fexWebUploaderConfig,
            accept:this.props.accept,
            auto: true,
        }
        const WebUploader = window.WebUploader;
        this.uploader = WebUploader.create(fileConfig);
        this.uploader.onUploadSuccess = function (file, response) {
            successFn && successFn(file, response);
        };
        this.uploader.on('uploadError', (file)=> {
            message.warning(Lang({id:"ShangChuanShiBai2",default:"上传失败"}))
            return false
        });
    }
    beforeUpload(file, files=[], fileList=[]){
        const { flagLimitType,accept } = this.state;
        if(accept){
            const sSuffix = getFileSuffix(file.name);
            const inx = accept.indexOf(sSuffix);
            if(inx<0){
                message.warning(Lang({id: 'WenJianGeShiBuZhengQue',default:'文件格式不正确，不能上传'}))
                return false;
            }
        }
        if(flagLimitType){ // 检查是不在可检查类型中
            if((files.length>1||fileList.length>0)){ // 如果限制类型，同一队列中有不同类型默认不可同时上传
                let type = '';
                // 检查 是否匹配准备上传队列 结束后 type必有值
                for(let key of files) {
                    const currType = this.checkType(getFileSuffix(key.name));
                    if (!isEmpty(type) && type !== currType) {
                        return false
                    }else type = currType;
                }
                // 检查 是否匹配已有列表
                for(let oldFile of fileList) {
                    const currType = this.checkType(oldFile.name);
                    if (type !== currType) {
                        return false
                    }
                }
            }
        }

    }
    uploadFile(options){
        this.uploader.addFile(options.file);
    }
    /****
     * 通用检查类型
     * 格式 可能是 jpg || .jpg
     * **/
    checkType(resoureType=''){
        let sType = '';
        if(resoureType.indexOf('xls')> -1||resoureType.indexOf('xls')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('pdf')> -1||resoureType.indexOf('PDF')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('doc')> -1||resoureType.indexOf('DOC')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('png')> -1||resoureType.indexOf('PNG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('gif')> -1||resoureType.indexOf('GIF')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpg')> -1||resoureType.indexOf('JPG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpeg')> -1||resoureType.indexOf('JPEG')> -1) {
            sType = 'pic';
        }
        return sType;
    }
    /**
     * 灵活修改 当前可接受的文件类型
     **/
    setAccept(file){
        const { accept, flagLimitType } = this.state;
        if(flagLimitType){ //限制文件类型的才会走这里
            let limitAccept = accept;
            const sFileUrl = file.fileUrl||'';
            const sSuffix = getFileSuffix(sFileUrl);
            const sType = this.checkType(sSuffix);
            const acceptlist = limitAccept.split(',');
            let sNewAccpt = '';
            acceptlist.forEach(typeAcc=>{
               const currType =  this.checkType(typeAcc); 
               if(currType==sType) sNewAccpt += typeAcc+','; 
            })
            this.setState({
                accept:sNewAccpt,
            })
        }
    }
    fileRemove(file){
        const fileList = [ ...this.state.fileList];
        let newAccept = this.state.accept;
        // console.log(fileList)
        const newFileList = fileList.filter(item=>item.uid!=file.uid)
        if(!newFileList||newFileList.length==0){newAccept= this.props.accept;}
        this.props.onChange(newFileList);
        this.setState({
            accept:newAccept,
            fileList: newFileList,
        });
    }
    /**
     * 编辑状态下 读取数据
     * */
    initFile(initValue){
        const yList = initValue||this.props.initValue || [];
        let setFile = []
        yList.forEach(file=>{
            if(!isEmpty(file.fileId)) setFile.push({
                ...file,
                uid:file.fileId,
                name:file.fileName
            })
        })
        this.setState({
            fileList:setFile
        })
        if(setFile.length>0){
            this.setAccept(setFile[0]);// 编辑时判断是否限制文件类型
        }

    }

    // 查看文件预览
    fileLook(data){
        window.open(data.fileUrl)
    }

    componentWillMount() {
       this.initFile()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(this.props.replace){
            if(nextProps.initValue&&(!this.props.initValue||this.props.initValue.length==0)){
                this.initFile(nextProps.initValue);
            }else{
                if(this.state.fileList.length>0&&(!this.props.initValue||this.props.initValue.length==0)){
                    this.initFile(nextProps.initValue);
                }
            }
        }
    }

    componentDidMount() {
        if(typeof window.WebUploader!='undefined'){
            const that = this;
            this.init(function (file, response={}) {
                const respModel = response.model;
                const sType = that.checkType(respModel.extend);
                const newFile = {
                    uid:respModel.id,
                    name:respModel.realName+'.'+respModel.extend,
                    fileName:respModel.realName+'.'+respModel.extend, // 对接后端保存时用此字段
                    fileId:respModel.id,
                    fileUrl:respModel.url,
                    type: sType,
                    status: 'done',
                };
                if(that.props.maxCount==1){ // 如果最大上传数为1即更新列队为此上传文件
                    const fileList = [newFile];
                    that.props.onChange(fileList);
                    that.setState({
                        fileList:fileList,
                    });
                }else {//todo 限制 maxCount
                    let fileList = [ ...that.state.fileList];
                    if(that.state.fileList.length==0)that.setAccept(newFile); // 如果原文件列表为0才去判断是否限制文件类型
                    fileList.push(newFile)
                    that.props.onChange(fileList);
                    that.setState({
                        fileList: fileList,
                    });
                }


            });
        }
    }
    render() {
        const { fileList,accept } = this.state;
        const { maxCount,multiple,replace,placeholder} = this.props;
        return (<div>
                {
                    replace?
                        <Upload name='file'
                                 multiple={multiple}
                                 accept={accept}
                                 maxCount={maxCount}
                                 showUploadList = {false}
                                 id={"filePicker"}
                                 beforeUpload={(current, files) =>this.beforeUpload(current, files,fileList)}
                                 customRequest={(options)=>this.uploadFile(options)}
                                 onRemove={file=>this.fileRemove(file)}
                                 fileList={fileList}>
                            {this.props.children}
                        </Upload>:
                        <Dragger name='file'
                                 multiple={multiple}
                                 accept={accept}
                                 maxCount={maxCount}
                                 onPreview={file=>this.fileLook(file)}
                                 id={"filePicker"}
                                 beforeUpload={(current, files) =>this.beforeUpload(current, files,fileList)}
                                 customRequest={(options)=>this.uploadFile(options)}
                                 onRemove={file=>this.fileRemove(file)}
                                 fileList={fileList}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">{Lang({id: 'DianJiHuoJiangWenJianTuoZhuaiDaoZheLiShangChuan',default:'点击或将文件拖拽到这里上传'})}</p>
                            <p className="ant-upload-hint">
                                {Lang({id: 'ZhiChiKuoZhanMing',default:'支持扩展名'})}：{placeholder||accept}
                            </p>
                        </Dragger>
                }
            </div> );
    }
}


export default UploadFileComponent;
